export * from './__generated__/remove-bg-image-upload-from-end-screen-setting-mutation.generated';
export * from './__generated__/set-bg-image-upload-to-end-screen-setting-mutation.generated';
export * from './__generated__/update-end-screen-setting-mutation.generated';
